import { useLoadingFacts } from "@hooks";
import { Box, Button, Modal, Typography } from "@mui/material";
import Lottie from "react-lottie";
import animationData from "../../../../assets/servers.json";

const defaultOptions = {
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export const WebsiteLoadingModal = ({
  isLoading,
  websiteUrl,
  onCancel,
}: {
  isLoading: boolean;
  websiteUrl: string;
  onCancel: () => void;
}) => {
  const { factIndex, fadeState, factsList } = useLoadingFacts({
    isLoading,
  });

  return (
    <Modal
      open={isLoading}
      aria-labelledby="loading-modal-title"
      aria-describedby="loading-modal-description"
    >
      <Box className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] bg-white rounded-lg shadow-2xl p-4 outline-none">
        <Box className="flex flex-col items-center gap-8">
          <div className="flex flex-col justify-center items-center">
            <div className="flex flex-col gap-y-2">
              <Typography
                id="loading-modal-title"
                variant="h6"
                className="text-center"
              >
                Parsing product info from{" "}
                <strong className="text-color-primary-darkest font-bold">
                  {websiteUrl}
                </strong>
              </Typography>
            </div>
            <Typography id="loading-modal-description" variant="body2">
              This will take a few seconds.
            </Typography>
          </div>
          <Lottie options={defaultOptions} width={300} height={200} />
          <Box
            sx={{
              height: "4em", // Fixed height container
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              id="did-you-know"
              variant="body2"
              className={`text-center ${fadeState}`}
              sx={{
                opacity: fadeState === "fade-in" ? 1 : 0,
                transition: "opacity 0.5s ease",
                width: "100%",
              }}
            >
              {factsList[factIndex]}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            color="error"
            onClick={onCancel}
            sx={{
              minWidth: 100,
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
